export default function() {
  const widgetName = 'headerButton';
  const widgetOpts = headerButtonOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: ''
    },
    cardWidgetLoaded: function(data, owl, hasData) {
      $('#cardWidget .card-widget-item').each(function(){
        var title = $(this).find('.card-widget-title');
        var titleText = title.text();
        var characterLimit = 10;

        if (titleText.length > characterLimit) {
          var trimmedText = titleText.substring(0, characterLimit) + '...';
          title.text(trimmedText);
        }
      });
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 1,
    moreButton: {
      visible: false,
      text: ''
    },
    scriptPath:  widgetOpts.scriptPath,
    showDescription: false,
    slideshow: false,
    textOverImage: false
  });

}